export default "__VITE_ASSET__D32qSQ$n__"